import { h } from "@stencil/core";
import { ServiceDocument } from "../../api/publicApi/serviceReports/document";

export const ReportItem = ({
    t,
    document,
    title,
    isOnMachinePage = false,
    machineNumber,
    machineAlias,
    machineName,
    technicianName
}: {
    t: (key: string) => string;
    document: ServiceDocument;
    title?: string;
    isOnMachinePage?: boolean;
    machineNumber?: string;
    machineAlias?: string;
    machineName?: string;
    technicianName?: string;
}) => {
    return (
        <div class="mf-service-reports__report-item" key={document.id}>
            {title && <h3 class="ux-text-title ux-text-title--light">{title}</h3>}
            <div class="ux-row">
                {!isOnMachinePage && machineNumber && (
                    <ReportData label={t("mf-service-calls:serviceReports.machineNameAndNumber")}>
                        <strong>{machineAlias}</strong> {machineName} - {machineNumber}
                    </ReportData>
                )}
                {!isOnMachinePage && technicianName && (
                    <ReportData label={t("mf-service-calls:serviceReports.technicianName")}>{technicianName}</ReportData>
                )}
                <ReportData label={t("mf-service-calls:serviceReports.creationDate")}>
                    <ux-date-time class="ux-date-time hydrated" utc={document.createdAt} format="DD.MM.YYYY HH:mm"></ux-date-time>
                </ReportData>
                {isOnMachinePage && (
                    <ReportData label={t("mf-service-calls:serviceReports.missionNumber")}>
                        <MissionLink document={document} />
                    </ReportData>
                )}
                <div class="mf-service-reports__report-spacer" />
                <DownloadButton t={t} document={document} />
            </div>
        </div>
    );
};

const ReportData = ({ label }: { label: string }, children: JSX.Element) => {
    return (
        <div class="ux-u-mr-xxs ux-col-12 ux-col-lg-auto ux-u-mt-xxs" key={label}>
            <span class="ux-u-d-block ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">{label}</span>
            <span class="ux-u-d-block ux-text-normal">{children}</span>
        </div>
    );
};

const DownloadButton = ({ t, document }: { t: (key: string) => string; document: ServiceDocument }) => {
    const { isDownloading, downloadError } = document.store.state;
    return (
        <div class="ux-u-ml-xl-auto ux-col-12 ux-col-lg-auto ux-u-mt-xxs ux-u-flex-ai-end ux-u-flex-as-end ux-u-flex-dir-column ux-u-d-flex">
            <ux-button icon="download" iconPlacement="end" disabled={isDownloading} onClick={() => document.download()}>
                {isDownloading ? (
                    <ux-loader
                        style={{
                            minWidth: "100px"
                        }}
                    />
                ) : (
                    t("mf-service-calls:serviceReports.openReport")
                )}
            </ux-button>
            {downloadError && <div class="error">{downloadError}</div>}
        </div>
    );
};

const MissionLink = ({ document }: { document: ServiceDocument }) => {
    const { missionLink } = document.store.state;
    if (!missionLink) {
        return document.mission.sisMissionId;
    }
    return (
        <a href={missionLink} class="ux-text-link ux-text-link--primary">
            {document.mission.sisMissionId} <ux-icon name="arrow-right" />
        </a>
    );
};
